import React from "react";
import dynamic from "next/dynamic";
import { FaqBlock } from "../index";

// Dynamic imports
const Accordion = dynamic(() => import("@/Components/Accordion/Accordion"));
import Section from "@/Components/LayoutComponents/Section";

interface FaqProps {
  data?: FaqBlock;
}

const Faq: React.FC<FaqProps> = ({ data }) => {
  return (
    <Section>
      <div className="container">
        <h2 className="text-heading-1 text-primary-text font-bold text-center capitalize max-w-[1230px] mx-auto">
          {data?.title}
        </h2>
        <div className="mt-10">
          <Accordion
            items={
              data?.faq?.map((faqItem: any) => ({
                question: faqItem?.question,
                answer: faqItem?.answer,
              })) ?? []
            }
          />
        </div>
      </div>
    </Section>
  );
};
export default Faq;
